export default "__VITE_ASSET__DSBalR90__";